/**
 * Contact page animations
 * - Email scramble effect on hover
 */
export function initContactPage() {
    const section = document.querySelector('.contact-section');
    if (!section) return;

    // Email scramble animation
    initEmailScramble(section);
}

/**
 * Email scramble effect on hover
 */
function initEmailScramble(section) {
    const emailLink = section.querySelector('.contact-email');
    if (!emailLink) return;

    const emailText = emailLink.querySelector('.contact-email-text');
    const originalEmail = emailLink.dataset.email || emailText.textContent;
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.';

    let isAnimating = false;
    let animationFrame;

    emailLink.addEventListener('mouseenter', () => {
        if (isAnimating) return;
        isAnimating = true;

        let iteration = 0;
        const maxIterations = originalEmail.length * 3;

        const animate = () => {
            emailText.textContent = originalEmail
                .split('')
                .map((char, index) => {
                    // Keep characters that have been "revealed"
                    if (index < iteration / 3) {
                        return originalEmail[index];
                    }
                    // Scramble the rest
                    if (char === '@' || char === '.') return char;
                    return chars[Math.floor(Math.random() * chars.length)];
                })
                .join('');

            iteration++;

            if (iteration < maxIterations) {
                animationFrame = requestAnimationFrame(animate);
            } else {
                emailText.textContent = originalEmail;
                isAnimating = false;
            }
        };

        animate();
    });

    emailLink.addEventListener('mouseleave', () => {
        cancelAnimationFrame(animationFrame);
        emailText.textContent = originalEmail;
        isAnimating = false;
    });
}
